import { Link } from 'react-router';
import { PanelLeftOpenIcon } from 'lucide-react';

import { appIdentity } from '@/app/app-config';
import { CouncilSwitcher } from '@/components/layout/council-switcher';
import { ProfileMenu } from '@/components/layout/profile-menu';
import { Button } from '@/components/ui/button';

function Brand() {
  const BrandIcon = appIdentity.icon;
  return (
    <Link
      to="/"
      className="focus-visible:ring-ring flex items-center gap-2 rounded-md font-semibold focus-visible:ring-2 focus-visible:outline-none"
    >
      <BrandIcon className="size-5" aria-hidden />
      <span className="text-sm tracking-tight">{appIdentity.name}</span>
    </Link>
  );
}

export function Header({ onMobileSidebarOpen }: { onMobileSidebarOpen: () => void }) {
  return (
    <header className="bg-background/95 supports-[backdrop-filter]:bg-background/60 border-border z-40 flex h-14 shrink-0 items-center border-b backdrop-blur">
      <div className="hidden h-full w-60 shrink-0 items-center px-4 md:flex">
        <Brand />
      </div>
      <div className="flex flex-1 items-center gap-2 px-4 md:gap-3 md:px-6">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMobileSidebarOpen}
          aria-label="Open sidebar"
          className="-ml-1 md:hidden"
        >
          <PanelLeftOpenIcon className="size-5" />
        </Button>
        <div className="md:hidden">
          <Brand />
        </div>
        <div className="ml-auto flex items-center gap-1">
          <CouncilSwitcher />
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
}
